var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"preloader",style:({
		backgroundImage: _vm.primaryBackground
			? ("url(" + _vm.primaryBackground + ")")
			: undefined,
		backgroundRepeat: _vm.primaryBackground ? 'no-repeat' : undefined,
		backgroundPosition: _vm.primaryBackground ? '0 0' : undefined,
		backgroundSize: _vm.primaryBackground ? 'cover' : undefined,
	})},[_c('Loader')],1)}
var staticRenderFns = []

export { render, staticRenderFns }